<template>
    <div class="builder-landing-container">
        <div id="video-header" class="video-container white">
            <picture>
                <source media="(max-width: 767px)" srcset="https://cdn.shopify.com/s/files/1/1363/8433/files/builder_mobile.png?v=1747057257">
                <img class="lazyload main-image" src="https://cdn.shopify.com/s/files/1/1363/8433/files/builde.png?v=1747057257" alt="builder"/>
            </picture>       
            <div class="title-container">
                <p class="title">Build the <br/>perfect gift</p>
                <button @click="changePage" class="happybox-button green border">Start customizing a box</button>
            </div>
        </div>
        <div id="howto" class="how-to">
            <div class="how-wrapper">
                <p class="title">How to Build a Gift Box</p>
                <div class="steps-container">
                    <div class="step">
                        <div class="n-container">
                            <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/1_2c66e3ab-32f1-471b-8cec-ab39c01bca8e.svg?v=1732290520" class="number" alt="step 1" width="30" height="30"/>
                            <p class="extra">Select your gifts</p>
                        </div>
                        <img class="main-image" src="https://cdn.shopify.com/s/files/1/1363/8433/files/step1_29403a40-b825-4dbb-b32c-e670a423650c.png?v=1743684012" />
                    </div>
                    <div class="step second">
                        <div class="n-container">
                            <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/2_80154837-6262-4262-a586-48750a4e452b.svg?v=1732290520" class="number" alt="step 2" width="30" height="30"/>
                            <p>Pick your packaging & <br/>
                                we’ll handwrite your card
                            </p>
                        </div>
                        <img class="main-image" src="https://cdn.shopify.com/s/files/1/1363/8433/files/step2_ab03ddbb-3ae3-4664-8d4e-eee6c5197b81.png?v=1743683379" />
                    </div>
                    <div class="step third">
                        <div class="n-container">
                            <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/3_e08da053-2b0e-41bc-afda-594d7cff9155.svg?v=1732290519" class="number" alt="step 3" width="30" height="30"/>
                            <p>
                                Sit back & <br/>
                                take all the credit
                            </p>
                        </div>
                        <video class="main-image" autoplay="autoplay" playsinline="" muted="" loop="loop" alt="gif" src="https://cdn.shopify.com/videos/c/o/v/473dce62fe9d49d4ade3b0136cf1b987.mp4"></video>
                    </div>
                </div>
                <button @click="changePage" class="happybox-button green border">Start customizing a box</button>
            </div>
        </div>
        <div class="giftspiration">
            <div class="title-container">
                <p class="main-title">Builder Giftspiration</p>
                <p class="subtitle">See what others have sent</p>
            </div>
            <div class="content-container flicker-wrapper">
                <Flicking ref="flicking" class="flicking-goc-collection" :plugins="plugins1" :options="{ align: 'prev', circular: true, preventDefaultOnDrag: true,preventClickOnDrag: true, panelsPerView: panelsQty }">
                    <div class="inspiration">
                        <img class="main-image lazyload" alt="builder" src="https://cdn.shopify.com/s/files/1/1363/8433/files/Giftspiration.png?v=1734968930" width="300" height="400"/>
                    </div>
                    <div class="inspiration">
                        <img class="main-image lazyload" alt="builder" src="https://cdn.shopify.com/s/files/1/1363/8433/files/Mask_Group_3094-min.png?v=1733257449" width="300" height="400"/>
                    </div>
                    <div class="inspiration">
                        <img class="main-image lazyload" alt="builder" src="https://cdn.shopify.com/s/files/1/1363/8433/files/Mask_Group_3093-min.png?v=1733257449" width="300" height="400"/>
                    </div>
                    <div class="inspiration">
                        <img class="main-image lazyload" alt="builder" src="https://cdn.shopify.com/s/files/1/1363/8433/files/Mask_Group_3098-min.png?v=1733257448" width="300" height="400"/>
                    </div>
                    <div class="inspiration">
                        <img class="main-image lazyload" alt="builder" src="https://cdn.shopify.com/s/files/1/1363/8433/files/Mask_Group_3097-min.png?v=1733257448" width="300" height="400"/>
                    </div>
                    <div class="inspiration">
                        <img class="main-image lazyload" alt="builder" src="https://cdn.shopify.com/s/files/1/1363/8433/files/Mask_Group_3092-min.png?v=1733257448" width="300" height="400"/>
                    </div>
                </Flicking>
                <img @click="$refs.flicking.prev();" src="https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546" class="arrow-left"/>
                <img @click="$refs.flicking.next();" src="https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546" class="arrow-right"/>
            </div>
        </div>
        <div class="happy-clients">
            <div class="ticker-wrap">
            <div class="ticker">
                <div class="slide">
                <img class="lazyload" width="1678" height="67" data-src="https://cdn.shopify.com/s/files/1/1363/8433/files/logos_d6cd25b6-2f6f-422d-b06e-bee48844c2cb.svg?v=1675281939"/>
                </div>
                <div class="slide">
                <img class="lazyload" width="1678" height="67" data-src="https://cdn.shopify.com/s/files/1/1363/8433/files/logos_d6cd25b6-2f6f-422d-b06e-bee48844c2cb.svg?v=1675281939"/>
                </div>
            </div>
            </div>
        </div>
        <div class="testimonials">
            <p class="main-title"><span>Happy</span> Clients</p>
            <div class="testimonials-wrapper">
                <Flicking ref="testimonial" class="flicking-goc-collection" :plugins="plugins2" :options="{ align: 'prev', circular: true, preventDefaultOnDrag: true,preventClickOnDrag: true, panelsPerView: testimonialsPanels }">
                    <div class="testimonial">
                <div>
                    <img width="121" height="50" data-src="https://cdn.shopify.com/s/files/1/1363/8433/files/logo1.svg?v=1675714911" alt="Pfizer Logo" class="logo big lazyload">
                    <p>“I can’t even begin to tell you how delighted I am! The package and the gifts are terrific. Please thank your wonderful team on our behalf!”</p>
                    <p>- Ron K<br>Pfizer</p>
                </div>
                <img width="100" height="17" data-src="https://cdn.shopify.com/s/files/1/1363/8433/files/stars_b69c938c-d760-480a-89ca-87c58943361a.svg?v=1697040058" alt="5 Stars" class="stars lazyload">
                </div>
                <div class="testimonial">
                <div>
                    <img width="121" height="50" data-src="https://cdn.shopify.com/s/files/1/1363/8433/files/logo2.svg?v=1675714911" alt="The Agency Logo" class="logo big lazyload">
                    <p>“From gift box curation to shipping, the Happy Box team is truly dedicated, creative & helpful!”</p>
                    <p>- The Whitman Team<br>The Agency</p>
                </div>
                <img width="100" height="17" data-src="https://cdn.shopify.com/s/files/1/1363/8433/files/stars_b69c938c-d760-480a-89ca-87c58943361a.svg?v=1697040058" alt="5 Stars" class="stars lazyload">
                </div>
                <div class="testimonial">
                <div>
                    <img width="121" height="50" data-src="https://cdn.shopify.com/s/files/1/1363/8433/files/logo3.svg?v=1675714911" alt="Rocket Insights Logo" class="logo lazyload">
                    <p>“Happy Box helped us problem solve gifting our new remote hires!”</p>
                    <p>- Imogene, Majordomo<br>Rocket Insights</p>
                </div>
                <img width="100" height="17" data-src="https://cdn.shopify.com/s/files/1/1363/8433/files/stars_b69c938c-d760-480a-89ca-87c58943361a.svg?v=1697040058" alt="5 Stars" class="stars lazyload">
                </div>
                </Flicking>
            </div>
        </div>
    </div>
</template>

<script>
import { AutoPlay } from "@egjs/flicking-plugins";
export default {
     data() {
        return{
            plugins1: [new AutoPlay({ duration: 3000, direction: "NEXT", stopOnHover: false })],
            windowWidth: window.innerWidth,
        }
    },
    computed:{
        panelsQty(){
            if(this.windowWidth < 768)
                return 2

            return 4
        },
        plugins2(){
            if(this.windowWidth < 768)
                return [new AutoPlay({ duration: 3000, direction: "NEXT", stopOnHover: false })]

            return [];
        },
        testimonialsPanels(){
            if(this.windowWidth < 768)
                return 1

            return 3
        }
    },
    methods: {
        changePage(){
            this.$emit("changepage", true);
        },
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth
        })
    },
}
</script>

<style scoped>

.video-container{
    width: 100%;
    display: flex;
    position: relative;
}

.video-container .main-image{
    width: 100%;
    height: auto;
}

.video-container .title-container{
    width: 50%;
    position: absolute;
    top: 0%;
    left: 5%;
    bottom: 5%;
    text-align: center;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 2%;
    bottom: 0%;
}

.video-container .title-container .title{
    font-family: Founders Grotesk, sans-serif;
    font-size: 6.5vw;
    line-height: 0.9;
    margin-bottom: 3%;
    text-align: left;
    margin-left: 5%;
}

.video-container  .title-container .title span{
    font-style: italic;
    font-family: Founders Grotesk, sans-serif;
}


.video-container  .title-container .legend{
    color: #c3ff01;
    font-size: 2.5vw;
    font-family: ff-more-web-pro-condensed, Karla, sans-serif;
    transform: rotate(-15deg);
    position: absolute;
    right: 23%;
    bottom: 27%;
    font-style: italic;
    text-transform: uppercase;
}

.video-container  .title-container .instructions{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.video-container  .title-container .instructions div{
    width: 26%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.video-container  .title-container .instructions div img{
    margin-bottom: 0.5rem;
    height: 5vw;
}

.video-container  .title-container .instructions .first img{
    max-width: 50%;
}

.video-container .title-container .instructions .last img{
    padding: 2%;
}

.video-container .title-container .instructions div{
    font-size: 1.2vw;
    line-height: 1.2;
    font-weight: bold;
}


.how-to .steps-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

     .how-to .step{
        width: 30%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
    }

     .how-to .step .circle-step{
        margin: unset;
        position: absolute;
        border-radius: 50%;
        border: 1px solid #0f0c38;
        width: 16%;
        background-color: #fcf6ef;
        aspect-ratio: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: moret;
        font-weight: 300;
        font-size: 2vw;
    }

    .how-to .step .n-container{
        display: flex;
        width: 80%;
        gap: 15px;
    }

     .how-to .step p{
        font-size: 1.15vw;
        margin: 0.5rem 0;
        line-height: 1.2;
        text-align: left;
    }

    .how-to .step .extra{
        margin: 1rem;
    }

    .how-to .step .number{
        width: 3vw;
        height: auto;
    }

     .how-to .step .main-image{
        width: 100%;
    }

    .third .main-image{
        padding: 0% 6%;
    }

     .step-video video{
        width: 95%;
        min-width: unset;
        margin-top: 5%;
    }

     .step-video .circle{
        position: absolute;
        width: 14%;
        top: -2%;
        left: 39.5%;
    }



    .how-to{
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        background-color: #fffaf7;
    }

    .how-to .how-wrapper{
        padding: 2% 5%;
    }

    .how-to .title{
        font-size: 3vw;
        font-family: ff-more-web-pro-condensed, Karla, sans-serif;
        margin-bottom: 1rem;
    }

    .how-to .happybox-button{
        padding: 1% 10%;
        margin-top: 1rem;
    }

     /* Ticker styling */
	.happy-clients{
    position: relative;
    width: 100%;
    overflow: hidden;
  }

  .happy-clients .title{
    text-align: center;
    color: #0f0c38;
    font-family: "Karla", sans-serif;
    font-weight: bold;
    font-size: 1.5vw;
    line-height: 1.2;
    margin-top: 1rem;
    margin-bottom: unset;
  }

  .how-to .main-title,.adventure-section .main-title{
    text-align: center;
    color: #0f0c38;
    font-family: Founders Grotesk, sans-serif;
    font-weight: 300;
    font-size: 4vw;
    margin: 0.5rem 0 1.5rem;
    line-height: 1.2;
  }

  .ticker-wrap {
    position: relative;
    width: 100%;
    overflow: hidden;
    margin: 0;
    padding: 0;
	  border-top: 1px solid black;
    border-bottom: 1px solid black;
    background-color: #fffdbf;
  }

  .ticker-wrap .ticker {
    overflow: hidden;
    height: 100%;
    white-space: nowrap;
    animation: scrollText 15s infinite linear;
    margin: 0;
    font-size: 0;
    display: flex;
    justify-content: space-between;
    width: fit-content;
    gap: 15px;
  }

  .slide {
    display: inline-block;
    margin: 0;
    padding: 0;
    color: white;
    padding: 15px 0px;
  }

  .slide img{
    height: 100%;
    width: auto;
  }

  @keyframes scrollText {
    from {
      transform: translateX(0%);
    }
    to {
      transform: translateX(-50%);
    }
  }
  /*Ticker end */

    .testimonials {
		display: flex;
		justify-content: space-between;
		padding: 5% 10%;
        flex-direction: column;
        align-items: center;
        background-color: #e6ecff;
	}

    .testimonials .main-title{
        text-align: center;
        color: #0f0c38;
        font-family: "ff-more-web-pro-condensed", "Karla", sans-serif;
        font-weight: 300;
        font-size: 3vw;
        margin-bottom:1.5rem;
        line-height: 1.2;
    }

    .testimonials .main-title span{
        color: #0f0c38;
        font-family: "ff-more-web-pro-condensed", "Karla", sans-serif;
        font-weight: 300;
        font-size: 3vw;
        line-height: 1.2;
        font-style: italic;
    }

  .testimonials .testimonials-wrapper{
    display: flex;
    width: 100%;
    justify-content: space-between;
  }

	.testimonial{
		background-color: white;
		border-radius: 10px;
		padding: 20px;
		width: 32%;
		text-align: center;
		box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
        margin-right: 1rem;
	}

	.testimonial .logo {
		width: 50px;
		height: auto;
		margin-bottom: 10px;
	}

	.testimonial .logo.big{
		width: auto;
		height: 50px;
	}

	.testimonial p {
		margin: 10px 0;
		font-size: 1.15vw;
		line-height: 1.2;
	}

	.testimonial .stars {
		width: 100px;
		height: auto;
		margin-top: 10px;
	}

	.testimonial p:last-of-type {
		font-weight: bold;
		margin-top: 15px;
	}

    .giftspiration{
        width: 100%;
        padding: 3% 0%;
    }

  .giftspiration .title-container{
    display: flex;
    gap: 15px;
    justify-content: center;
    align-items: flex-end;
    margin-bottom: 1rem;
  }

  .giftspiration .title-container .main-title{
    font-family: Founders Grotesk, sans-serif;
    font-weight: 300;
    font-size: 4vw;
    line-height: 1;
    margin: unset;
  }

  .giftspiration .title-container .subtitle{
    font-family: "ff-more-web-pro-condensed", "Karla", sans-serif;
    font-weight: 300;
    font-size: 3vw;
    line-height: 1;
    margin: unset;
    font-style: italic;
  }

  .giftspiration .content-container{
    width: 100%;
    display: flex;
    gap: 10px;
    position: relative;
  }

  .giftspiration .content-container .flicking-goc-collection{
    padding: 0% 5%;
  }

  .giftspiration .content-container .inspiration {
    width: 100%;
    transition: all 0.5s;
    display: block;
    position: relative;
    cursor: pointer;
    margin-right: 1rem;
  }

  .giftspiration .content-container .inspiration .main-image{
    width: 100%;
    height: auto;
  }

@media screen and (max-width: 767px){
    .happy-clients .title{
      font-size: 3vw;
    }

    .video-container .title-container{
        top: unset;
        bottom: 5%;
        height: unset;
        left: 0;
        right: unset;
        width: 100%;
    }

    .video-container .title-container .title{
        font-size: 16vw;
        line-height: 0.8;
        margin-bottom: 1rem;
        margin-left: unset;
        text-align: center;
    }

    .video-container .title-container .happybox-button, .how-to .happybox-button{
        padding: 2% 10%;
    }

    .how-to .title{
        font-size: 6vw;
    }

    .how-to .steps-container{
        align-items: center;
        flex-direction: column;
        padding-bottom: unset;
    }

    .how-to .step{
        width: 80%;
        padding-bottom: 5%;
    }

    .how-to .step .number{
        width: 8vw;
    }

    .how-to .step p{
        font-size: 3.5vw;
    }

    .giftspiration .title-container{
      flex-direction: column;
      gap: 0;
      align-items: center;
    }

    .giftspiration .title-container .main-title{
      font-size: 12vw;
      margin-bottom: 0.5rem;
    }

    .giftspiration .title-container .subtitle{
      font-size: 6vw;
    }

    .testimonials .main-title, .testimonials .main-title span{
      font-size: 8vw;
    }

    .testimonial p{
        font-size: 4vw;
        width: 100%;
    }

    .testimonials .swiper{
        padding: 10% 0 !important;
    }

    .testimonial{
        width: 100%;
        height: 100%;
    }

    .how-to .how-wrapper{
        padding: 5%;
    }

    .testimonials{
        padding: 5% 0;
    }

    .testimonials .flicking-goc-collection{
        padding: 0% 10%;
    }

    .third .main-image{
        padding: unset;
    }

}

</style>